import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import Quiz from "./pages/Quiz";
import CounsellorsDirectory from "./pages/CounsellorsDirectory";
import CourseFinder from "./pages/CourseFinder";
import UniversitiesDirectory from "./pages/UniversitiesDirectory";
import UniversityDetail from "./pages/UniversityDetail";
import Compare from "./pages/Compare";
import CountryGuides from "./pages/CountryGuides";
import CountryGuide from "./pages/CountryGuide";
import SavedDashboard from "./pages/SavedDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import HigherEducation from "./pages/HigherEducation";
import VerticalDetail from "./pages/VerticalDetail";
import SchoolRegister from "./pages/SchoolRegister";
import SchoolLogin from "./pages/SchoolLogin";
import SchoolDashboard from "./pages/SchoolDashboard";
import CompareBar from "./components/CompareBar";
import { CompareProvider } from "./context/CompareContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";

function HomeShell() {
  return (
    <>
      <Header />
      <Home />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CompareProvider>
            <Routes>
              <Route path="/" element={<HomeShell />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/assessment" element={<Quiz />} />
              <Route path="/counsellors" element={<CounsellorsDirectory />} />
              <Route path="/course-finder" element={<CourseFinder />} />
              <Route path="/universities" element={<UniversitiesDirectory />} />
              <Route path="/universities/:id" element={<UniversityDetail />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/destinations" element={<CountryGuides />} />
              <Route path="/destinations/:slug" element={<CountryGuide />} />
              <Route path="/higher-education" element={<HigherEducation />} />
              <Route path="/higher-education/:slug" element={<VerticalDetail />} />
              <Route path="/school/register" element={<SchoolRegister />} />
              <Route path="/school/login" element={<SchoolLogin />} />
              <Route path="/school/dashboard" element={<SchoolDashboard />} />
              <Route path="/saved" element={<SavedDashboard />} />
              <Route path="/login" element={<Auth />} />
              <Route path="/signup" element={<Auth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <CompareBar />
          </CompareProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
